const skills = [
    {
        name: 'JavaScript',
        logo: 'devicon-javascript-plain colored-text',
    },
    {
        name: 'TypeScript',
        logo: 'devicon-typescript-plain colored-text',
    },
    {
        name: 'React',
        logo: 'devicon-react-original colored-text',
    },
    {
        name: 'Next.js',
        logo: 'devicon-nextjs-plain colored-text',
    },
    {
        name: 'Redux',
        logo: 'devicon-redux-original colored-text',
    },
    {
        name: 'Vue.js',
        logo: 'devicon-vuejs-plain colored-text',
    },
    {
        name: 'Node.js',
        logo: 'devicon-nodejs-plain colored-text',
    },
    {
        name: 'Express',
        logo: 'devicon-express-original colored-text',
    },
    {
        name: 'GraphQL',
        logo: 'devicon-graphql-plain colored-text',
    },
    {
        name: 'MongoDB',
        logo: 'devicon-mongodb-plain colored-text',
    },
    {
        name: 'PostgreSQL',
        logo: 'devicon-postgresql-plain colored-text',
    },
    {
        name: 'AWS',
        logo: 'devicon-amazonwebservices-original colored-text',
    },
    {
        name: 'Docker',
        logo: 'devicon-docker-plain colored-text',
    },
    {
        name: 'Tailwind CSS',
        logo: 'devicon-tailwindcss-plain colored-text',
    },
    {
        name: 'Jest',
        logo: 'devicon-jest-plain colored-text',
    },
];
export default skills;
